import React from "react";

/**
 * Stylised Ashoka Chakra — 24-spoke wheel.
 * Color is inherited from `currentColor`, so animation via a parent class
 * (`.chakra-icon`) can cycle hue. Size driven by font-size / props.
 */
export const Chakra = ({ size = 16, strokeWidth = 1.5, className = "" }) => {
    const spokes = Array.from({ length: 24 }, (_, i) => (i * 360) / 24);
    return (
        <svg
            data-testid="ashoka-chakra"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            width={size}
            height={size}
            className={className}
            style={{ color: "currentColor" }}
            aria-hidden
        >
            {/* Outer ring */}
            <circle
                cx="50"
                cy="50"
                r="46"
                fill="none"
                stroke="currentColor"
                strokeWidth={strokeWidth + 0.4}
            />
            {/* Inner hub */}
            <circle cx="50" cy="50" r="6" fill="currentColor" />
            {/* 24 spokes */}
            <g stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round">
                {spokes.map((deg) => (
                    <line
                        key={deg}
                        x1="50"
                        y1="50"
                        x2="50"
                        y2="6"
                        transform={`rotate(${deg} 50 50)`}
                    />
                ))}
            </g>
        </svg>
    );
};
